/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PublicationUrl } from './PublicationUrl';
import {
    PublicationUrlFromJSON,
    PublicationUrlFromJSONTyped,
    PublicationUrlToJSON,
    PublicationUrlToJSONTyped,
} from './PublicationUrl';

/**
 * 
 * @export
 * @interface RetailerApiAccess
 */
export interface RetailerApiAccess {
    /**
     * 
     * @type {Set<PublicationUrl>}
     * @memberof RetailerApiAccess
     */
    publicationUrls: Set<PublicationUrl>;
    /**
     * 
     * @type {RetailerApiAccessStatusEnum}
     * @memberof RetailerApiAccess
     */
    status: RetailerApiAccessStatusEnum;
}


/**
 * @export
 */
export const RetailerApiAccessStatusEnum = {
    Active: 'ACTIVE',
    Disabled: 'DISABLED'
} as const;
export type RetailerApiAccessStatusEnum = typeof RetailerApiAccessStatusEnum[keyof typeof RetailerApiAccessStatusEnum];


/**
 * Check if a given object implements the RetailerApiAccess interface.
 */
export function instanceOfRetailerApiAccess(value: object): value is RetailerApiAccess {
    if (!('publicationUrls' in value) || value['publicationUrls'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function RetailerApiAccessFromJSON(json: any): RetailerApiAccess {
    return RetailerApiAccessFromJSONTyped(json, false);
}

export function RetailerApiAccessFromJSONTyped(json: any, ignoreDiscriminator: boolean): RetailerApiAccess {
    if (json == null) {
        return json;
    }
    return {
        
        'publicationUrls': (new Set((json['publicationUrls'] as Array<any>).map(PublicationUrlFromJSON))),
        'status': json['status'],
    };
}

export function RetailerApiAccessToJSON(json: any): RetailerApiAccess {
    return RetailerApiAccessToJSONTyped(json, false);
}

export function RetailerApiAccessToJSONTyped(value?: RetailerApiAccess | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'publicationUrls': (Array.from(value['publicationUrls'] as Set<any>).map(PublicationUrlToJSON)),
        'status': value['status'],
    };
}

